



import ClickOutside from 'vue-click-outside';
import {Vue, Component, Model, Prop, Watch} from 'vue-property-decorator';
import emojiRegexp from '@/utils/emojiRegexp';

@Component({
  directives: {ClickOutside}
})
export default class ValidateInput extends Vue {
  @Prop() private errFlg?: string;

  @Prop() private options?: any;
  private inputInfo: any = {
    name: 'validate',
  };

	@Prop({ required: false, default: false })
	private readonly disabled: boolean;

  private initOver = false;

  private showValue: string = '';
  @Model('change') readonly value!: any;
  @Watch('value', {immediate: false, deep: false})
  onValueChanged(next: string) {
    this.showValue = next;
  }

  private closeErr() {
    if (this.errFlg !== 'maxErr') {
      this.$emit('update:errFlg', '');
    }
  }

  private blurCheck(ev: any) {
    this.inputCheck(ev, true);
  }
  private inputCheck(ev: any, blurFlg: boolean = false) {
    if (ev.keyCode === 13) {
      this.$emit('enterUp');
      return;
    }
    if (ev.keyCode !== 16 && ev.keyCode !== 17) {
      this.$emit('update:errFlg', '');
      let tempVal = ev.target.value;
      if (this.inputInfo.type === 'company-name') {
        tempVal = tempVal.replace(emojiRegexp, '');
      } else if (this.inputInfo.type === 'no-common-special') {
	      tempVal = tempVal.replace(/['"<>₩\\‘”`]/g, '');
      } else if (this.inputInfo.type === 'partner-name') {
        tempVal = tempVal.replace(emojiRegexp, '');
      } else if (this.inputInfo.type === 'no-symbol-strict') {
        tempVal = tempVal.replace(/[^a-zA-Z0-9ㄱ-힣\s]/g, '');
      } else if (this.inputInfo.type === 'eng-num') {
        tempVal = tempVal.replace(/[^a-zA-Z0-9]/g, '');
      } else if (this.inputInfo.type === 'email-local') {
        tempVal = tempVal.replace(/[^a-zA-Z0-9+\-_!#$%&'*/=?^`{|}~.]+/g, '');
      } else if (this.inputInfo.type === 'email-domain') {
        tempVal = tempVal.replace(/[^a-zA-Z0-9.-]/g, '');
      } else if (this.inputInfo.type === 'text-num') {
        tempVal = tempVal.replace(/[^0-9]/g, '');
      } else if (this.inputInfo.type === 'num-bar') {
        tempVal = tempVal.replace(/[^0-9-]/g, '');
      } else if (this.inputInfo.type === 'negative-num') {
        tempVal = tempVal.replace(/[^0-9-]/g, '');
        if (tempVal.indexOf('-') > 0) {
          tempVal = tempVal.replace(/[^0-9]/g, '');
        } else if (tempVal.indexOf('-') === 0) {
          tempVal = '-' + tempVal.replace(/[^0-9]/g, '');
        }
      } else if (this.inputInfo.type === 'dec') {
        tempVal = '';
        let pointCnt = 0;
        for (let item of ev.target.value) {
          if (item === '.') {
            pointCnt++;
          }
          if (item !== item.replace(/[^0-9.]+/g, '') || pointCnt > 1) {
            break;
          } else {
            tempVal += item;
          }
        }

        if (tempVal.indexOf('.') === 0) {
          tempVal = '';
        } else {
          let tempValues = tempVal.split('.');
          let limit = this.inputInfo.limit === undefined ? 10 : this.inputInfo.limit;
          if (tempValues[0].length > limit) {
            tempVal = tempVal.substr(0, limit);
          } else {
            let digits = this.inputInfo.digits === undefined ? 2 : this.inputInfo.digits;
            if (tempValues[1] !== undefined && tempValues[1].length > digits) {
              tempVal = tempVal.substr(0, tempValues[0].length + 1 + digits);
            }
          }
        }
      }
      if (tempVal !== ev.target.value) {
        this.$emit('update:errFlg', 'typeErr');
      }
      if (this.inputInfo.type === 'negative-num' && tempVal !== '') {
        if (tempVal.indexOf('-') > -1 && tempVal.length > 1) {
          tempVal = Number(tempVal);
        }
      }
      if (blurFlg) {
        if (this.inputInfo.type === 'dec' || this.inputInfo.type === 'text-num') {
          if (tempVal !== '') {
            tempVal = Number(tempVal).toString();
          }
        }
        if (this.inputInfo.type === 'negative-num') {
          if (tempVal !== '' && tempVal !== '-') {
            tempVal = Number(tempVal).toString();
          }
        }
        if (this.inputInfo.max !== undefined) {
          if (this.inputInfo.max < Number(tempVal)) {
            tempVal = '';
            this.$emit('update:errFlg', 'maxErr');
          }
        }
        if (this.inputInfo.min !== undefined) {
          if (this.inputInfo.min > Number(tempVal)) {
            tempVal = '';
            this.$emit('update:errFlg', 'minErr');
          }
        }
      }
      if (this.inputInfo.maxlength !== undefined) {
        tempVal = tempVal.substr(0, this.inputInfo.maxlength);
      }
      ev.target.value = tempVal;
      this.$emit('change', tempVal);
    }
    this.$emit('keyup');
  }
  private focus() {
    (this.$refs.validateInput as any).focus();
  }

  private async initOption() {
    if (this.options) {
      Object.assign(this.inputInfo, this.options);
    }
    if (this.value !== undefined) {
      this.showValue = this.value;
    }
    this.initOver = true;
  }
  private async mounted() {
    await this.initOption();
  }
}
